export default __webpack_public_path__ + "static/media/smm.1f3d80a3.mp4";